export const sourceFields = {
  x: [
    { key: "since", label: "Since", type: "date" },
    { key: "until", label: "Until", type: "date" },
  ],
  youtube: [],
  ecommerce: [
    { key: "category", label: "Category", type: "text" },
    { key: "priceMin", label: "Min Price", type: "number" },
    { key: "priceMax", label: "Max Price", type: "number" },
    { key: "ratingMin", label: "Min Rating", type: "number" },
  ],
};
